export default "__VITE_ASSET__4f5ee901__"